import { APP_NAME } from "./appLinks";

// Render the reader's Bible coverage as a shareable "constellation" graphic.
// readFlags: boolean[] in canonical chapter order; one dot per chapter.
export function makeJourneyImage({ readFlags, total, overallPct, chaptersRead, streak }) {
  const W = 1080, H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  // background — deep night with a warm dawn glow
  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#0b1020");
  bg.addColorStop(0.6, "#121529");
  bg.addColorStop(1, "#1c150b");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W / 2, H, 60, W / 2, H, H * 0.8);
  glow.addColorStop(0, "rgba(224,184,92,0.18)");
  glow.addColorStop(1, "rgba(224,184,92,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  ctx.textAlign = "center";

  // title
  ctx.fillStyle = "#E0B85C";
  ctx.font = "700 34px -apple-system, 'Segoe UI', Roboto, sans-serif";
  ctx.fillText("MY READING JOURNEY", W / 2, 118);

  // big headline
  ctx.fillStyle = "#ffffff";
  ctx.font = "700 88px Georgia, 'Times New Roman', serif";
  ctx.fillText(`${overallPct}%`, W / 2, 230);
  ctx.fillStyle = "rgba(255,255,255,0.75)";
  ctx.font = "500 34px -apple-system, 'Segoe UI', Roboto, sans-serif";
  ctx.fillText("of the Bible read", W / 2, 282);

  // constellation grid — one dot per chapter
  const cols = 41;
  const rows = Math.ceil(total / cols);
  const gx0 = 96, gw = W - 192, cell = gw / cols, gy0 = 360, r = 6;
  for (let i = 0; i < total; i++) {
    const col = i % cols, row = Math.floor(i / cols);
    const cx = gx0 + col * cell + cell / 2;
    const cy = gy0 + row * cell + cell / 2;
    ctx.beginPath();
    if (readFlags[i]) {
      ctx.fillStyle = "#E0B85C";
      ctx.shadowColor = "rgba(224,184,92,0.85)";
      ctx.shadowBlur = 10;
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
    } else {
      ctx.shadowBlur = 0;
      ctx.fillStyle = "rgba(255,255,255,0.09)";
      ctx.arc(cx, cy, r - 1, 0, Math.PI * 2);
    }
    ctx.fill();
  }
  ctx.shadowBlur = 0;

  // stats row
  const statsY = gy0 + rows * cell + 90;
  ctx.fillStyle = "#ffffff";
  ctx.font = "700 46px Georgia, serif";
  ctx.fillText(`${chaptersRead.toLocaleString()} chapters  ·  ${streak}-day streak`, W / 2, statsY);

  // footer
  ctx.fillStyle = "rgba(255,255,255,0.9)";
  ctx.font = "700 32px -apple-system, 'Segoe UI', Roboto, sans-serif";
  ctx.fillText(APP_NAME, W / 2, H - 96);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "500 25px -apple-system, 'Segoe UI', Roboto, sans-serif";
  ctx.fillText("Track your journey free on Google Play", W / 2, H - 56);

  return new Promise((resolve) => canvas.toBlob((b) => resolve(b), "image/png", 0.92));
}
